import { useCallback } from 'react';

export const useGetStreamData = () => {
	const getStreamData = useCallback((stream, key) => {
		return Array.isArray(stream[key])
			? stream[key][0].variable
			: stream[key].variable;
	}, []);

	return { getStreamData };
};
